/// Tiny className joiner. We don't pull in `clsx` for this one helper —
/// 8 lines is cheaper than another dependency in the bundle.
export type ClassValue = string | number | false | null | undefined;

export const cn = (...values: ClassValue[]): string =>
  values.filter((v): v is string | number => Boolean(v)).join(' ');
